import OperatorTdsDeclarationTypes from './types';

export const fetchOperatorDetailsStart = (payload: any) => ({
  type: OperatorTdsDeclarationTypes.FETCH_OPERATOR_DETAILS_START,
  payload: payload,
});

export const fetchOperatorDetailsSuccess = (payload: any) => ({
  type: OperatorTdsDeclarationTypes.FETCH_OPERATOR_DETAILS_SUCCESS,
  payload: payload,
});

export const fetchOperatorDetailsFailure = (errorMessage: any) => ({
  type: OperatorTdsDeclarationTypes.FETCH_OPERATOR_DETAILS_FAILURE,
  payload: errorMessage,
});

export const initiateOperatorTdsDeclarationStart = (payload: any) => ({
  type: OperatorTdsDeclarationTypes.INITIATE_OPERATOR_TDS_DECLARATION_START,
  payload: payload,
});

export const initiateOperatorTdsDeclarationSuccess = (payload: any) => ({
  type: OperatorTdsDeclarationTypes.INITIATE_OPERATOR_TDS_DECLARATION_SUCCESS,
  payload: payload,
});

export const initiateOperatorTdsDeclarationFailure = (payload: any) => ({
  type: OperatorTdsDeclarationTypes.INITIATE_OPERATOR_TDS_DECLARATION_FAILURE,
  payload: payload,
});
